/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_2_OverlineInputs */

const en_mk_agent_2_overline = /** @type {(inputs: Mk_Agent_2_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put up a fence`)
};

const id_mk_agent_2_overline = /** @type {(inputs: Mk_Agent_2_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beri pagar`)
};

/**
* | output |
* | --- |
* | "Put up a fence" |
*
* @param {Mk_Agent_2_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_2_overline = /** @type {((inputs?: Mk_Agent_2_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_2_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_2_overline(inputs)
	return en_mk_agent_2_overline(inputs)
});